// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  position: relative;
  ${(props) =>
    props.overrideWidth > 0 &&
    css`
      width: ${props.overrideWidth}%;
      max-width: ${props.overrideWidth}%;
    `}
`;

export const ScrollWrapper = styled.div`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
  overscroll-behavior-x: contain;
  flex: 1;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    gap: 8px;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    gap: 16px;
  }

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    scroll-snap-type: x mandatory;
  }

  ${(props) =>
    props.overrideGap > 0 &&
    css`
      gap: ${props.overrideGap}px !important;
    `}
`;

export const Arrow = styled.button`
  display: ${(props) => (props.show ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: absolute;
  background-image: url(${() => getIconPath('family-outfit-arrow')});
  background-repeat: no-repeat;
  background-position: center center;
  background-color: rgb(245, 245, 245);
  background-size: 24px 24px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  z-index: 2;
  border: none;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 4px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.8;
  ${(props) =>
    props.left
      ? `
  left: 10px;
  transform: rotateY(180deg) translate(0px, -50%);
  `
      : `right: 10px`};

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    display: none;
  }
`;
